import { render, staticRenderFns } from "./CmgPickupDeliveryToggle.vue?vue&type=template&id=2ff9fa2d&scoped=true&lang=pug&"
import script from "./cmg-pickup-delivery-toggle.ts?vue&type=script&lang=ts&"
export * from "./cmg-pickup-delivery-toggle.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPickupDeliveryToggle.vue?vue&type=style&index=0&id=2ff9fa2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9fa2d",
  null
  
)

export default component.exports